export default {
    apiKey: "AIzaSyAO6-vYKrXdWBLzJLNlnTj7q2SELMb042w",
    authDomain: "vuetaiwan-prototype.firebaseapp.com",
    projectId: "vuetaiwan-prototype",
    storageBucket: "vuetaiwan-prototype.appspot.com",
    messagingSenderId: "1068560130168",
    appId: "1:1068560130168:web:6c8addf0d34bc8ff698d8d"
}